<div class="m-b-20" *ngIf="labReports.length > 0; else showNoLabRequirementMessage">
  <div class="heading-tab">
    <h3 class="heading"><i nz-icon nzType="file-done" nzTheme="outline"></i> Lab Requirements
    </h3>
  </div>
  <nz-collapse>
    <nz-collapse-panel
      *ngFor="let reports of labReports; let labIndex = index;"
      [nzHeader]="reports.requirementCd"
      [nzActive]="labIndex == 0"
    >
      <div>
        <div *ngIf="!reports.labData || reports.labData.length <= 0">
          <button nz-button (click)="showUploadLabReportPopup(reports);OCRprocessBill()" class="m-t-10 d-i-b">
            <span><i nz-icon nzType="upload" class="anticon anticon-upload"></i> Add Lab Report</span>
          </button>
        </div>
        <div class="m-t-20" *ngIf="reports.labData && reports.labData.length > 0">
          <div class="w-100-pc">
            <div class="flexie-auto-grid">
              <h5 class="d-b p-t-b-10">
                <span>All Health Parameters extracted from uploaded lab reports</span>
              </h5>
            </div>
            <nz-table #basicTable [nzData]="reports.labData" nzSize="small" [nzShowPagination]="false" class="d-b" [nzScroll]="{x: '480px'}">
              <thead>
              <tr>
                <th style="width:40px"></th>
                <th>Test</th>
                <th>Result</th>
                <th>Unit</th>
                <th>Normal Range</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let u of basicTable.data">
                <td><nz-avatar style="color:#f56a00; background-color:#fde3cf;" nzSize="default" nzIcon="user" ></nz-avatar></td>
                <td>
                  <a>{{u.testCd}}</a>
                </td>
                <td>{{u.measureValue}}</td>
                <td>{{u.measureUnitCd}}</td>
                <td>{{u.referenceMinValue}} - {{u.referenceMaxValue}} {{u.referenceMeasureUnitCd}}</td>
                <td>
                  <a (click)="modalBill=true;OCRprocessBill()">Rectify Value</a>
                </td>
              </tr>
              </tbody>
            </nz-table>
          </div>
        </div>

      </div>
    </nz-collapse-panel>
  </nz-collapse>
</div>

<ng-template #showNoLabRequirementMessage>
  <nz-alert nzType="info" nzMessage="No lab report requirement has been generated."></nz-alert>
</ng-template>

<div>
  <!-- Bills -->
  <!-- <div class="heading-tab">
    <h3 class="heading"><i nz-icon nzType="profile"></i> Bill Headers</h3>
    <button nz-button nzType="primary" (click)="modalBill=true;OCRprocessBill()">View Bills/OCR</button>
  </div> -->

  <nz-table *ngIf="false" [nzData]="[1,2]" [nzShowPagination]="false" [nzScroll]="{ x: '1700px' }" class="table-valign-top" [nzSize]="'default'">
    <thead>
      <tr>
        <th style="width: 30px">
          <!--Leave empty-->
        </th>
        <th style="width: 30px">Sr</th>
        <th style="width: 230px">Bill No</th>
        <th style="width: 120px">Bill Date</th>
        <th style="width: 140px">Bill Type</th>
        <th style="width: 140px">Provider</th>
        <th style="width: 120px">Total Bill Amount</th>
        <th style="width: 120px">Bill Status</th>
        <th style="width: 200px">Approved Amount</th>
        <th style="width: 230px">Details</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let b of bills; let i=index;">
        <!-- MAIN -->
        <tr>
          <td nzShowExpand [(nzExpand)]="b.expanded"></td>
          <td data-dd="Number" class="text-a-center">
            {{i+1}}
          </td>
          <td data-dd="Bill No">
            <input type="text" nz-input [ngModel]="'SRKH/JUN20/29/PCR-92'+(i+19)+''+(i*12)+''" />
            <!-- Bill Scan upload -->
            <div *ngIf="i==0" class="d-b m-t-20">
              <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" [nzFileList]="fileList">
                <button nz-button><i nz-icon nzType="upload"></i><span>Upload</span></button>
              </nz-upload>
            </div>
          </td>
          <td data-dd="Date">
            <nz-date-picker style="width:100%" [ngModel]="'29 Jun 2020'" [nzFormat]="'DD MMM YYYY'"></nz-date-picker>
          </td>
          <td data-dd="Type">
            <nz-select [ngModel]="'Hospital'" style="width:100%" [disabled]="false" class="w-100-pc">
              <nz-option [nzLabel]="'Medicine'" [nzValue]="'Medicine'"></nz-option>
              <nz-option [nzLabel]="'Ambulance'" [nzValue]="'Ambulance'"></nz-option>
              <nz-option [nzLabel]="'Hospital'" [nzValue]="'Hospital'"></nz-option>
              <nz-option [nzLabel]="'Lab'" [nzValue]="'Lab'"></nz-option>
            </nz-select>
          </td>
          <td data-dd="Provider">
            <nz-select [ngModel]="'Select'" style="width:100%" [disabled]="false" class="w-100-pc">
            </nz-select>
          </td>
          <td data-dd="Total Amt">
            <nz-select [ngModel]="'Rated'" style="width:100%" [disabled]="false" class="w-100-pc">
              <nz-option [nzLabel]="'Standard'" [nzValue]="'Standard'"></nz-option>
              <nz-option [nzLabel]="'Rated'" [nzValue]="'Rated'"></nz-option>
              <nz-option [nzLabel]="'Reject'" [nzValue]="'Reject'"></nz-option>
            </nz-select>
          </td>
          <td data-dd="Bill Status">
            <nz-select [ngModel]="'Approved'" style="width:100%" [disabled]="false" class="w-100-pc">
            </nz-select>
          </td>
          <td data-dd="Approved">
            <input type="text" nz-input [disabled]="false" />
          </td>
          <td data-dd="Details">
            <textarea nz-input cols="2" rows="2" placeholder="Remarks ..." [disabled]="false"></textarea>
          </td>
        </tr>
        <!--CHILD -- CHANGE *ngIf LOGIC -->
        <tr *ngIf="bills_child.length" [nzExpand]="b.expanded" style="background: #FFF;">
          <td>
            <!-- Leave empty -->
          </td>
          <td colspan="16">
            <h5 class="d-b p-t-b-5">Bill Details</h5>
            <div class="bg-white nested-child-table">
              <nz-table #innerTable [nzData]="[0]" nzSize="small" [nzScroll]="{ x: '580px' }"
                [nzShowPagination]="false">
                <!-- CHILD TABLE HEADER -->
                <thead>
                  <tr>
                    <th style="width: 250px">Item</th>
                    <th style="width: 60px;">Quantity</th>
                    <th style="width: 120px">Rate</th>
                    <th style="width: 120px">Bill Amount</th>
                    <th style="width: 120px">Status</th>
                    <th style="width: 120px">Approved Amount</th>
                  </tr>
                </thead>
    <tbody>
      <!-- CHILD TABLE DATA -->
      <tr *ngFor="let data of bills_child">
        <td>
          <!-- Item (DD) -->
          <nz-select [ngModel]="data.name" nzSize="default" nzShowSearch style="width: 100%">
            <nz-option [nzLabel]="data.name" [nzValue]="data.name"></nz-option>
            <nz-option *ngFor="let x of items" [nzLabel]="x.name" [nzValue]="x.name"></nz-option>
          </nz-select>
        </td>
        <td data-dd="Quantity"><input type="text" nz-input [disabled]="false" [ngModel]="1"
            style="width: 100%; max-width: 60px;" class="text-a-right" /></td>
        <td data-dd="Rate"><input type="text" nz-input [disabled]="false" [ngModel]="data.amount" style="width: 100%;"
            class="text-a-right" /></td>
        <td data-dd="Bill Amount"><input type="text" nz-input [disabled]="false" [ngModel]="data.amount"
            style="width: 100%;" class="text-a-right" /></td>
        <td>
          <nz-select [ngModel]="'Draft'" style="width:100%" [disabled]="false" class="w-100-pc">
            <nz-option [nzLabel]="'Draft'" [nzValue]="'Draft'"></nz-option>
            <nz-option [nzLabel]="'Approved'" [nzValue]="'Approved'"></nz-option>
          </nz-select>
        </td>
        <td data-dd="Approved Amt"><input type="text" nz-input [disabled]="false" [ngModel]="data.amount"
            style="width: 100%" class="text-a-right" /></td>
      </tr>
    </tbody>
  </nz-table><!-- childTable -->
</div>
</td>
</tr>
</ng-container>
</tbody>
</nz-table><!-- parentTable -->

<!-- Space -->
<div class="spacer p-t-b-20"></div>

<!-- Bills SUB (NOW unused -- used nexted tables above) -- >
  <div class="heading-tab">
    <h3 class="heading"><i nz-icon nzType="profile"></i> Bill Details</h3>
    <button nz-button nzType="primary" (click)="modalBill=true;OCRprocessBill()">View Bills/OCR</button>
  </div>
 <!-- -->

</div><!-- enclosing div-->



<!-- MODAL -->
<nz-modal [(nzVisible)]="modalBill" nzTitle="Lab Reports"
          nzClosable
          (nzOnOk)="importSelected()"
          (nzOnCancel)="modalBill=false"
          nzWidth="86%"
          [nzOkText] = "null"
>
<ng-container *nzModalContent>
  <div>
    <nz-spin [nzSpinning]="processingOCR" nzTip="Processing OCR...">
      <div class="grid grid-2x grid-gap-20">

        <!-- O C R -->
        <div>
          <div class="heading-tab">
            <h3 class="heading"><i nz-icon nzType="profile"></i> Reports</h3>
            <button nz-button nzType="primary" (click)="OCRprocessBill()">Re-Scan OCR</button>
          </div>

          <!-- File upload + preview + file switcher -->
          <div class="has-ocr">
            <!-- <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/"
                       [nzFileList]="fileList"
                       nzListType="picture-card"
                       [nzPreview]="handlePreview"
                       [nzRemove]="handlePreview"
                       [className]="'has-ocr'"
            >
              <i nz-icon nzType="plus"></i>
              <div class="ant-upload-text">Upload</div>
            </nz-upload> -->

            <nz-upload [nzLimit]="1" [(nzFileList)]="fileList" [nzBeforeUpload]="fileUploadBefore" [nzShowUploadList]="showUploadList"
               *ngIf="!readonly" nzListType="picture-card" [nzPreview]="handlePreview" [className]="'has-ocr'"> <!--[nzShowButton]="fileList.length < 1"-->
              <div class="ant-upload-text" (click)="setUploadParams(currentRequirementObjToUploadLabReport,0, clientRefGuid)"> Upload</div>
            </nz-upload>
            <div *ngFor="let dc of documentCollection">
              <ng-container *ngFor="let file of dc.documents; let ind=index;">
                <a (click)="saveUpdateOCRData(file.guid)">{{file.entityImageName}}</a><br>
                </ng-container>
            </div>

            <!-- <img [src]="previewImage" class="w-100-pc" alt="report"/> -->

          </div>
        </div>

        <!-- DATA TABLE -->
        <div *ngIf="OCR_Result && OCR_Result.length > 0" >
          <div class="heading-tab">
            <h3 class="heading"><i nz-icon nzType="profile"></i> Data</h3>
            <button nz-button nzType="primary" (click)="saveUpdateOCRData()">Update Data</button>
            <!-- <button nz-button nzType="primary" (click)="importSelected()">Import Selected</button> -->
          </div>
          <nz-table [nzData]="[1,2]" [nzShowPagination]="false" [nzScroll]="{ x: '580px' }" class="table-valign-top"
            [nzSize]="'small'">
            <thead>
            <tr>
              <!-- <th style="width:32px" class="text-a-center">
                <label nz-checkbox nzValue="A" [ngModel]="true" [nzIndeterminate]="true"></label>
              </th> -->
              <th style="width: 230px">Test</th>
              <th style="width: 230px">Result</th>
              <th style="width: 120px">Units</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let res of OCR_Result; let i=index;">
              <!-- <td data-dd="Number" class="text-a-center">
                <label nz-checkbox [nzValue]="res" [ngModel]="res.checked" [disabled]="res.duplicate"></label>
              </td> -->
              <!-- Item Name (Must use algo to match OCR with our list of items) -->
              <td data-dd="Item" [ngClass]="{'inputs-are-disabled':res.duplicate}">
                <input type="text" nz-input placeholder="Test name" nzSize="default" [ngModel]="res.testCd" style="max-width: 160px" class="text-a-right" />
                <!-- <nz-select [ngModel]="res.name" nzSize="small" nzShowSearch style="width: 100%">
                  <nz-option [nzLabel]="res.name" [nzValue]="res.name"></nz-option>
                  <nz-option *ngFor="let x of items" [nzLabel]="x.name" [nzValue]="x.name"></nz-option>
                </nz-select> -->
              </td>
              <!-- Should be editable even for duplicate cases -->
              <td data-dd="Amount">
                <!--Rs.--> <input type="text" nz-input placeholder="Result" nzSize="default" [ngModel]="res.value" style="max-width: 160px" class="text-a-right" /> <!--ensure to copy classes too-->
              </td>
              <!-- Status : Exists / Yet to be added? -->
              <td>
                {{res.measureUnitCd}}
                <!-- {{ i.duplicate? 'Already exists':'' }} -->
              </td>
            </tr>
            </tbody>
          </nz-table>


        </div>

      </div>
    </nz-spin>
  </div>
  </ng-container>
</nz-modal>
